import React from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';
import { CheckSolidIcon, TimesSolidIcon } from '../../shared/icons/icons';

import { ProductData } from '../../shared/types/graphql-types';
import { ARTICLE_STATUSES } from '../../shared/constants/products';

import styles from './product-article-status-banner.scss';

interface ProductArticleStatusBannerProps {
  className?: string;
  product: ProductData;
  showCheckMark?: boolean;
}

function ProductArticleStatusBanner(props: ProductArticleStatusBannerProps) {
  const {
    className,
    product: { articleStatus, articleStatusLabel, productLaunchDate } = {},
    showCheckMark = true
  } = props;

  return (
    <div
      className={cn(
        styles['container'],
        `${className || ''} product-article-status-banner`
      )}
    >
      {(articleStatus === ARTICLE_STATUSES.DISCONTINUED ||
        articleStatus === ARTICLE_STATUSES.BACKORDER ||
        articleStatus === ARTICLE_STATUSES.QUALITY_HOLD ||
        articleStatus === ARTICLE_STATUSES.TEMPORARILY_UNAVAILABLE) && (
        <TimesSolidIcon className={styles['icon-discontinued']} />
      )}
      {articleStatus === ARTICLE_STATUSES.PRE_LAUNCH && showCheckMark && (
        <CheckSolidIcon className={styles['icon-prelaunch']} />
      )}
      <Typography
        className={cn(styles['label'], 'product-article-status-banner__label')}
        tag="strong"
        weight="bold"
      >{`${articleStatusLabel}${
        productLaunchDate && articleStatus === ARTICLE_STATUSES.PRE_LAUNCH
          ? `: ${productLaunchDate}`
          : ''
      }`}</Typography>
    </div>
  );
}

export default ProductArticleStatusBanner;
